
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33874',
  depVersions: {
  "documents-public-ui": "static-1.33874",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33879",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1886",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5352",
  "hs-test-utils": "static-1.7767",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11183",
  "I18n": "static-7.1558",
  "jasmine-immutable": "static-1.2780",
  "jasmine-runner": "static-1.6235",
  "lodash": "static-1.3",
  "quartz": "static-1.6676",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16402",
  "reporting-data": "static-1.66350",
  "reporting-testing-lib": "static-1.8283",
  "reporting-visualizations": "static-1.58426",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4527",
  "webpack-env": "static-1.54",
  "atom": "static-1.4832",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2247",
  "classnames": "static-2.10",
  "cssUtils": "static-1.720",
  "customer-data-filters-ui": "static-1.38739",
  "customer-data-objects": "static-1.7405",
  "customer-data-property-utils": "static-1.7833",
  "data-fetching-client": "static-1.9438",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4292",
  "flux-actions": "static-1.302",
  "FormsCommonComponents": "static-1.85203",
  "FormUrlGenerator": "static-2.4492",
  "foundations-components": "static-1.7440",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11491",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6924",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3621",
  "property-translator": "static-1.5175",
  "quartz-config": "static-1.454",
  "quartz-core": "static-1.5895",
  "quick-fetch": "static-1.3697",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5139",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7921",
  "reference-resolvers-lite": "static-1.7851",
  "report-customization-components": "static-1.12377",
  "reporting-enablement": "static-1.21939",
  "reporting-reports": "static-1.66028",
  "reporting-snowflake": "static-1.54968",
  "reporting-ui-components": "static-2.63622",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4393",
  "sales-content-partitioning": "static-1.8696",
  "SalesContentIndexUI": "static-3.8844",
  "sanitize": "static-1.4236",
  "sanitize-text": "static-1.7901",
  "self-service-api": "static-1.9999",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1515",
  "signup-constants": "static-1.18308",
  "signup-ui-lego-core": "static-1.20318",
  "signup-ui-url-generator": "static-2.7823",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4533",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10756",
  "ui-addon-i18n": "static-1.10892",
  "ui-addon-react-router-dom": "static-1.9309",
  "ui-addon-upgrades": "static-9.17592",
  "ui-asset-management-lib": "static-1.10657",
  "ui-images": "static-2.1081",
  "UIComponents": "static-3.8130",
  "usage-tracker": "static-1.7095",
  "usage-tracker-container": "static-1.7085",
  "usage-tracker-core": "static-1.6945",
  "usage-tracker-public": "static-1.6906",
  "viral-links-lib": "static-1.6788",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3192",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2953",
  "quartz-webpack": "static-1.2900",
  "ai-components-ui-library": "static-1.8238",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4593",
  "foundations-theming": "static-1.4170",
  "quartz-auth": "static-1.351",
  "usage-tracker-session-replay": "static-1.4781",
  "foundations-theming-base": "static-1.3155",
  "HeadJS": "static-2.701",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2878",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4092",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7688",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3468",
  "reporting-client-types": "static-1.2371",
  "hs-story-utils": "static-1.9189",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9382",
  "hubspotter-http": "static-1.4443",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7011",
  "crm-message-bus": "static-1.42234",
  "customer-data-filters-ui-msw-helpers": "static-1.21173",
  "customer-data-objects-ui-components": "static-1.12764",
  "customer-data-reference-ui-components": "static-1.12902",
  "customer-data-ui-utilities": "static-1.9586",
  "framework-builder-read-service-client": "static-1.3812",
  "framework-data-schema-quick-fetch": "static-1.6535",
  "framework-data-schema-resolvers": "static-1.6630",
  "inbound-db-properties-service-client": "static-1.3641",
  "multi-account-reference-resolvers": "static-1.730",
  "onboarding-tours": "static-1.16205",
  "reporting-datasets-permissions-lib": "static-1.12931",
  "ui-addon-teams": "static-1.21187",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67507",
  "customer-data-properties": "static-1.50665",
  "forms-ai-lib": "static-1.3953",
  "forms-utils-lib": "static-1.12097",
  "foundations-components-test-utils": "static-1.4923",
  "react-dnd-compat": "static-1.4385",
  "react-tinymce": "static-1.54515",
  "tinymce-config": "static-2.53641",
  "ui-gdpr-components": "static-1.10108",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3709",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1086",
  "ui-fonts": "static-1.445",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.784",
  "mobile-manifest-mixins": "static-1.474",
  "quartz-head": "static-1.341",
  "quartz-i18n": "static-1.351",
  "quartz-routing": "static-1.106",
  "quartz-test": "static-1.351",
  "batch-promise": "static-1.1311",
  "external-options-client-types": "static-1.3948",
  "react-colorpicker": "static-2.9973",
  "copilot-toolkit": "static-1.10423",
  "data-quality-ui-library": "static-1.12230",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40536",
  "reporting-insights-lib": "static-1.1047",
  "reporting-plugins": "static-1.9932",
  "ui-addon-draggable-compat": "static-2.4015",
  "ui-addon-opt": "static-4.8148",
  "ui-shepherd-react": "static-3.9906",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24615",
  "hubspot-apollo-client": "static-1.4640",
  "sales-templates-service-types-lib": "static-1.3958",
  "ui-business-units-lib": "static-1.8784",
  "merchandise-lib": "static-1.257",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5427",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3869",
  "upgrade-management-service-types": "static-1.4269",
  "timezone-utils": "static-2.5005",
  "bender-build-tools": "static-1.2899",
  "chatspot-core": "static-1.20154",
  "chirp-fetch": "static-1.1644",
  "bend-plugin-foundations-theming": "static-1.2653",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9380",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3588",
  "crm-pipelines-api-client-types": "static-1.3929",
  "multi-currency-client-types": "static-1.3483",
  "getting-started-shared-tasks": "static-1.17771",
  "growth-data-modal": "static-1.5115",
  "growth-onboarding-confetti": "static-1.2831",
  "growth-onboarding-next-action-utils": "static-1.1256",
  "navigation-components": "static-1.17141",
  "onboarding-tours-client": "static-1.4419",
  "onboarding-tours-utils": "static-1.271",
  "ui-shepherd-tracker": "static-1.7287",
  "ui-universal-auth": "static-1.8638",
  "user-context": "static-1.4856",
  "cms-field-types": "static-1.4568",
  "content-icons-ui": "static-1.2140",
  "integrations-lib": "static-1.15289",
  "calling-global-api": "static-1.63527",
  "calling-internal-common": "static-1.31053",
  "calling-lifecycle-internal": "static-1.64909",
  "calling-lifecycle-messages": "static-1.57203",
  "commerce-products-lib": "static-1.8734",
  "crm-links": "static-1.6015",
  "file-manager-components": "static-1.22769",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.432",
  "inbounddb-objects-service-types": "static-1.4015",
  "meetings-icalendar-utils-lib": "static-1.395",
  "object-builder-ui-client": "static-1.47841",
  "pipeline-validation-client-types": "static-1.3752",
  "property-value-citations": "static-1.1279",
  "pulse": "static-1.262",
  "smart-property-lib": "static-1.5738",
  "tiered-pricing": "static-1.772",
  "ui-addon-iframeable": "static-1.8802",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19406",
  "tinymce-themes": "static-1.55611",
  "data-token-picker": "static-1.15980",
  "hub-http-contrib": "static-1.2806",
  "interframe": "static-3.4553",
  "tinymce-data": "static-1.39726",
  "tinymce-plugins": "static-1.56755",
  "ui-addon-sales-email": "static-1.4974",
  "magpie-lib": "static-1.5355",
  "magpie-types": "static-1.4815",
  "simple-logging-lib": "static-1.2812",
  "content-assistance-lib": "static-1.7389",
  "dashboard-lib": "static-1.80454",
  "ExportDialog": "static-6.10149",
  "hubspot-prosemirror": "static-1.17493",
  "hubspot-prosemirror-plugins": "static-1.17485",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8451",
  "campaign-roi-lib": "static-1.8167",
  "feedback-loader": "static-1.28778",
  "onboarding-scopes": "static-1.6226",
  "apollo-link-hub-http": "static-2.4410",
  "hubspot-apollo-cache": "static-1.99",
  "growth-monetization-service-types": "static-1.4285",
  "nav-client-types": "static-1.2117",
  "purchase-motions-api": "static-1.5430",
  "trials-service-types": "static-1.3686",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.487",
  "getting-started-shared-tasks-store": "static-1.16889",
  "integrations-error-boundary-lib": "static-1.12704",
  "integrations-tracking-lib": "static-1.5345",
  "native-integrations-shared-strings": "static-1.7550",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10134",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31059",
  "shared-worker-versioning": "static-1.10799",
  "calling-usage-tracker": "static-1.6300",
  "voice-sms-access-library": "static-1.121",
  "customer-data-tracking": "static-1.6643",
  "products-iframe-lib": "static-1.7211",
  "products-ui-components-shared-msw-handlers": "static-1.9764",
  "location-customization-utils-lib": "static-1.8435",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3916",
  "video-components-external": "static-1.10459",
  "video-data-lib": "static-1.34117",
  "directed-graph": "static-1.698",
  "event-emitter": "static-1.709",
  "breeze-intelligence-kit": "static-1.5261",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9465",
  "fsm": "static-1.3493",
  "policy-lib": "static-1.6546",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9528",
  "navigation-messaging": "static-1.6468",
  "FileManagerLib": "static-1.38409",
  "NamespacedHubStyle": "static-2.8861",
  "FileManagerCore": "static-1.38268",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11961",
  "layout-dnd-utils": "static-1.10936",
  "react-codemirror": "static-1.10389",
  "ui-addon-emoji-picker": "static-1.9651",
  "ui-brand-identity-lib": "static-1.13675",
  "ui-addon-video-player": "static-1.8456",
  "ui-coaching-tips": "static-1.27839",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8329",
  "payment-link-components": "static-1.22827",
  "EmailSignatureEditor": "static-1.23859",
  "eligibility-engine-service-types": "static-1.2967",
  "universal-page-editor-lib": "static-1.2760",
  "calling-orchestration-schema": "static-1.34898",
  "sales-views-client-types": "static-1.4053",
  "crm-record-cards-service-types": "static-1.3416",
  "content-media-composition-data-lib": "static-1.11310",
  "content-media-compositions": "static-2.15317",
  "media-bridge-lib": "static-1.18502",
  "trellis-story-utils": "static-1.4283",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5553",
  "FileManagerImages": "static-1.35920",
  "video-components": "static-1.12462",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4294",
  "video-embed": "static-1.34951",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67582",
  "layout-data-lib": "static-1.9261",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6346",
  "commerce-tours-lib": "static-1.5662",
  "growth-onboarding-reliability": "static-1.4850",
  "sales-checkout-service-client": "static-1.3438",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21243",
  "sales-email-signature-service-client": "static-1.3604",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21245",
  "outpost": "static-1.3969",
  "advanced-menus-core": "static-1.14758",
  "advanced-menus-lib": "static-1.11741",
  "ui-memberships-settings-lib": "static-1.33324",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14757",
  "simple-menus-lib": "static-1.16274"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33874",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33879",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1886",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5352",
  "hs-test-utils": "/hs-test-utils/static-1.7767",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11183",
  "I18n": "/I18n/static-7.1558",
  "jasmine-immutable": "/jasmine-immutable/static-1.2780",
  "jasmine-runner": "/jasmine-runner/static-1.6235",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6676",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16402",
  "reporting-data": "/reporting-data/static-1.66350",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8283",
  "reporting-visualizations": "/reporting-visualizations/static-1.58426",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4527",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4832",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2247",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.720",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38739",
  "customer-data-objects": "/customer-data-objects/static-1.7405",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7833",
  "data-fetching-client": "/data-fetching-client/static-1.9438",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4292",
  "flux-actions": "/flux-actions/static-1.302",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85203",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4492",
  "foundations-components": "/foundations-components/static-1.7440",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11491",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6924",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3621",
  "property-translator": "/property-translator/static-1.5175",
  "quartz-config": "/quartz-config/static-1.454",
  "quartz-core": "/quartz-core/static-1.5895",
  "quick-fetch": "/quick-fetch/static-1.3697",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5139",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7921",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7851",
  "report-customization-components": "/report-customization-components/static-1.12377",
  "reporting-enablement": "/reporting-enablement/static-1.21939",
  "reporting-reports": "/reporting-reports/static-1.66028",
  "reporting-snowflake": "/reporting-snowflake/static-1.54968",
  "reporting-ui-components": "/reporting-ui-components/static-2.63622",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4393",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8696",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8844",
  "sanitize": "/sanitize/static-1.4236",
  "sanitize-text": "/sanitize-text/static-1.7901",
  "self-service-api": "/self-service-api/static-1.9999",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1515",
  "signup-constants": "/signup-constants/static-1.18308",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20318",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7823",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4533",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10756",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10892",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9309",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17592",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10657",
  "ui-images": "/ui-images/static-2.1081",
  "UIComponents": "/UIComponents/static-3.8130",
  "usage-tracker": "/usage-tracker/static-1.7095",
  "usage-tracker-container": "/usage-tracker-container/static-1.7085",
  "usage-tracker-core": "/usage-tracker-core/static-1.6945",
  "usage-tracker-public": "/usage-tracker-public/static-1.6906",
  "viral-links-lib": "/viral-links-lib/static-1.6788",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3192",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2953",
  "quartz-webpack": "/quartz-webpack/static-1.2900",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8238",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4593",
  "foundations-theming": "/foundations-theming/static-1.4170",
  "quartz-auth": "/quartz-auth/static-1.351",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4781",
  "foundations-theming-base": "/foundations-theming-base/static-1.3155",
  "HeadJS": "/HeadJS/static-2.701",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2878",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4092",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7688",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3468",
  "reporting-client-types": "/reporting-client-types/static-1.2371",
  "hs-story-utils": "/hs-story-utils/static-1.9189",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9382",
  "hubspotter-http": "/hubspotter-http/static-1.4443",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7011",
  "crm-message-bus": "/crm-message-bus/static-1.42234",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21173",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12764",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12902",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9586",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3812",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6535",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6630",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3641",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.730",
  "onboarding-tours": "/onboarding-tours/static-1.16205",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12931",
  "ui-addon-teams": "/ui-addon-teams/static-1.21187",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67507",
  "customer-data-properties": "/customer-data-properties/static-1.50665",
  "forms-ai-lib": "/forms-ai-lib/static-1.3953",
  "forms-utils-lib": "/forms-utils-lib/static-1.12097",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4923",
  "react-dnd-compat": "/react-dnd-compat/static-1.4385",
  "react-tinymce": "/react-tinymce/static-1.54515",
  "tinymce-config": "/tinymce-config/static-2.53641",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10108",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3709",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1086",
  "ui-fonts": "/ui-fonts/static-1.445",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.784",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.474",
  "quartz-head": "/quartz-head/static-1.341",
  "quartz-i18n": "/quartz-i18n/static-1.351",
  "quartz-routing": "/quartz-routing/static-1.106",
  "quartz-test": "/quartz-test/static-1.351",
  "batch-promise": "/batch-promise/static-1.1311",
  "external-options-client-types": "/external-options-client-types/static-1.3948",
  "react-colorpicker": "/react-colorpicker/static-2.9973",
  "copilot-toolkit": "/copilot-toolkit/static-1.10423",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12230",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40536",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1047",
  "reporting-plugins": "/reporting-plugins/static-1.9932",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4015",
  "ui-addon-opt": "/ui-addon-opt/static-4.8148",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9906",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24615",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4640",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3958",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8784",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5427",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3869",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4269",
  "timezone-utils": "/timezone-utils/static-2.5005",
  "bender-build-tools": "/bender-build-tools/static-1.2899",
  "chatspot-core": "/chatspot-core/static-1.20154",
  "chirp-fetch": "/chirp-fetch/static-1.1644",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2653",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9380",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3588",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3929",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3483",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17771",
  "growth-data-modal": "/growth-data-modal/static-1.5115",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2831",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1256",
  "navigation-components": "/navigation-components/static-1.17141",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4419",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.271",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7287",
  "ui-universal-auth": "/ui-universal-auth/static-1.8638",
  "user-context": "/user-context/static-1.4856",
  "cms-field-types": "/cms-field-types/static-1.4568",
  "content-icons-ui": "/content-icons-ui/static-1.2140",
  "integrations-lib": "/integrations-lib/static-1.15289",
  "calling-global-api": "/calling-global-api/static-1.63527",
  "calling-internal-common": "/calling-internal-common/static-1.31053",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64909",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57203",
  "commerce-products-lib": "/commerce-products-lib/static-1.8734",
  "crm-links": "/crm-links/static-1.6015",
  "file-manager-components": "/file-manager-components/static-1.22769",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.432",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4015",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.395",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47841",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3752",
  "property-value-citations": "/property-value-citations/static-1.1279",
  "pulse": "/pulse/static-1.262",
  "smart-property-lib": "/smart-property-lib/static-1.5738",
  "tiered-pricing": "/tiered-pricing/static-1.772",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8802",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19406",
  "tinymce-themes": "/tinymce-themes/static-1.55611",
  "data-token-picker": "/data-token-picker/static-1.15980",
  "hub-http-contrib": "/hub-http-contrib/static-1.2806",
  "interframe": "/interframe/static-3.4553",
  "tinymce-data": "/tinymce-data/static-1.39726",
  "tinymce-plugins": "/tinymce-plugins/static-1.56755",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4974",
  "magpie-lib": "/magpie-lib/static-1.5355",
  "magpie-types": "/magpie-types/static-1.4815",
  "simple-logging-lib": "/simple-logging-lib/static-1.2812",
  "content-assistance-lib": "/content-assistance-lib/static-1.7389",
  "dashboard-lib": "/dashboard-lib/static-1.80454",
  "ExportDialog": "/ExportDialog/static-6.10149",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17493",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17485",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8451",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8167",
  "feedback-loader": "/feedback-loader/static-1.28778",
  "onboarding-scopes": "/onboarding-scopes/static-1.6226",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4410",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.99",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4285",
  "nav-client-types": "/nav-client-types/static-1.2117",
  "purchase-motions-api": "/purchase-motions-api/static-1.5430",
  "trials-service-types": "/trials-service-types/static-1.3686",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.487",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16889",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12704",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5345",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7550",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10134",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31059",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10799",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6300",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.121",
  "customer-data-tracking": "/customer-data-tracking/static-1.6643",
  "products-iframe-lib": "/products-iframe-lib/static-1.7211",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9764",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8435",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3916",
  "video-components-external": "/video-components-external/static-1.10459",
  "video-data-lib": "/video-data-lib/static-1.34117",
  "directed-graph": "/directed-graph/static-1.698",
  "event-emitter": "/event-emitter/static-1.709",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5261",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9465",
  "fsm": "/fsm/static-1.3493",
  "policy-lib": "/policy-lib/static-1.6546",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9528",
  "navigation-messaging": "/navigation-messaging/static-1.6468",
  "FileManagerLib": "/FileManagerLib/static-1.38409",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8861",
  "FileManagerCore": "/FileManagerCore/static-1.38268",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11961",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10936",
  "react-codemirror": "/react-codemirror/static-1.10389",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9651",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13675",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8456",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27839",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8329",
  "payment-link-components": "/payment-link-components/static-1.22827",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2967",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2760",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34898",
  "sales-views-client-types": "/sales-views-client-types/static-1.4053",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3416",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11310",
  "content-media-compositions": "/content-media-compositions/static-2.15317",
  "media-bridge-lib": "/media-bridge-lib/static-1.18502",
  "trellis-story-utils": "/trellis-story-utils/static-1.4283",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5553",
  "FileManagerImages": "/FileManagerImages/static-1.35920",
  "video-components": "/video-components/static-1.12462",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4294",
  "video-embed": "/video-embed/static-1.34951",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67582",
  "layout-data-lib": "/layout-data-lib/static-1.9261",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6346",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5662",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4850",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3438",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21243",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3604",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21245",
  "outpost": "/outpost/static-1.3969",
  "advanced-menus-core": "/advanced-menus-core/static-1.14758",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11741",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33324",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14757",
  "simple-menus-lib": "/simple-menus-lib/static-1.16274"
}
};
